function Ctrl($scope, $rootScope, $state, $stateParams, $timeout, authService, utilsService, userService, loggerService) {
  $scope.form = {
    email: null,
    password: null
  };

  $scope.loginSubmitted = false;
  $scope.loginSubmitting = null;
  $scope.loginResult = null;
  $scope.loginBtnOptions = {
    buttonDefaultText: 'Login',
    buttonSubmittingText: 'Logging in...',
    buttonSuccessText: 'Login succesful',
    buttonErrorText: 'Error logging in',
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonSuccessClass: 'btn-success',
    buttonErrorClass: 'btn-danger'
  };

  $scope.login = function(loginForm) {
    $scope.loginSubmitted = true;
    $scope.errorMsg = null;

    if (!loginForm.$valid) return;

    $scope.loginSubmitting = true;

    authService.login($scope.form.email, $scope.form.password, function success(response) {
      $scope.loginSubmitting = false;

      userService.listAffiliates({
          userId: response.user._id
        })
        .then(affiliateResponse => {
          if (!affiliateResponse || !affiliateResponse.length) {
            $timeout(() => {
              $scope.loginSubmitting = false;
              $scope.loginResult = 'error';
              $scope.errorMsg = 'Sorry you must be a Tablelist Affiliate to log in';

              loggerService.error($scope.errorMsg);

              $timeout(() => {
                $scope.errorMsg = null;
              }, 3000);
            }, 400);
          } else {

            $rootScope.affiliate = affiliateResponse[0];

            $timeout(function() {
              $scope.loginResult = 'success';

              $state.go('app.sales');
            }, 400);
          }
        })
        .catch(resp => {
          loggerService.error(resp);
        });
    }, function error(response) {
      $scope.loginSubmitting = false;
      $scope.loginResult = 'error';
      $scope.errorMsg = utilsService.errorMessage(response);

      $timeout(function() {
        $scope.errorMsg = null;
      }, 3000);

      loggerService.error(response);
    });
  };

  $scope.showForgotForm = false;
  $scope.forgotSubmitted = false;
  $scope.forgot = {
    email: ''
  };
  $scope.forgotPassword = function(form) {
    $scope.forgotSubmitted = true;

    if (form.$invalid) return;

    authService.forgotPassword($scope.forgot.email,
      function(response) {
        $scope.emailErrorMessage = '';
        $scope.emailSentMessage = response.message;
      },
      function(response) {
        $scope.emailSentMessage = '';
        $scope.emailErrorMessage = response.data.errors[0].message;
      });
  };
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  '$state',
  '$stateParams',
  '$timeout',
  'tl.auth.service',
  'utilsService',
  'tl.user.service',
  'loggerService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/login/loginCtrl.js